import { render } from "./personal.vue?vue&type=template&id=a9477a28&scoped=true"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"

import "./personal.vue?vue&type=style&index=0&id=a9477a28&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9477a28"]])

export default __exports__